import React from "react";
import { Link } from "react-router-dom";

export default function CookiePolicy() {
  return (
    <div className="py-16 md:py-24" data-testid="cookie-policy-page">
      <div className="container-tight max-w-3xl">
        <div className="overline">Legal</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-3 leading-[1.02]">
          Cookie <span className="text-primary">policy</span>.
        </h1>
        <p className="mt-6 text-foreground/60 text-sm">Last updated: 27 July 2026</p>

        <div className="prose prose-lg mt-12 space-y-8 text-foreground/80 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">1. What are cookies</h2>
            <p>
              Cookies are small text files that a website stores on your device to remember information between visits.
              This policy explains the cookies we use on the TGI Golfer Fund website and the choices you have.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">2. Cookies we use</h2>
            <p>We keep our cookie use to the minimum. We currently use the following categories:</p>
            <div className="mt-6 border border-border">
              <div className="p-5 border-b border-border">
                <div className="overline text-foreground/60">Strictly necessary</div>
                <div className="font-display text-xl mt-1">Authentication & session</div>
                <p className="text-sm text-foreground/70 mt-2">
                  Used to keep you signed in and to secure your session. Without these cookies, sign-in and account
                  features do not work. These cookies do not require consent under GDPR.
                </p>
                <div className="text-xs text-foreground/50 mt-3">Cookies: <code>access_token</code>, <code>refresh_token</code>, <code>session_token</code></div>
              </div>
              <div className="p-5 border-b border-border">
                <div className="overline text-foreground/60">Functional</div>
                <div className="font-display text-xl mt-1">Preferences</div>
                <p className="text-sm text-foreground/70 mt-2">
                  Used to remember your cookie choice and interface preferences. Stored locally in your browser.
                </p>
                <div className="text-xs text-foreground/50 mt-3">Storage: <code>tgi-cookie-consent</code></div>
              </div>
              <div className="p-5">
                <div className="overline text-foreground/60">Analytics & marketing</div>
                <div className="font-display text-xl mt-1">Not used</div>
                <p className="text-sm text-foreground/70 mt-2">
                  We do not currently use tracking, analytics or advertising cookies. If we introduce them in future,
                  you will be asked to opt in explicitly.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">3. Your choices</h2>
            <p>You can:</p>
            <ul className="mt-4 space-y-2 list-disc pl-6">
              <li>Accept or decline optional cookies from the banner at the bottom of the site.</li>
              <li>Delete cookies at any time via your browser settings.</li>
              <li>Block cookies via your browser settings, though this may break sign-in and other features.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">4. Third parties</h2>
            <p>
              When you use "Continue with Google" to sign in, Google's own authentication cookies may be set on your
              device by Google. Please refer to Google's own privacy and cookie policies for details.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">5. Contact</h2>
            <p>
              For any questions about cookies or your data, contact us at{" "}
              <a href="mailto:golfersfund@talkgolfireland.com" className="text-primary underline">
                golfersfund@talkgolfireland.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <Link to="/" className="btn-outline uppercase tracking-[0.18em] text-[12px]" data-testid="cookie-policy-home-link">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
